export const SALESCHANNEL_LOADING = "SALESCHANNEL_LOADING";
export const SALESCHANNEL_RESET = "SALESCHANNEL_RESET";
export const GET_SALESCHANNEL = "GET_SALESCHANNEL";
export const GET_SALESCHANNEL_SUCCESS = "GET_SALESCHANNEL_SUCCESS";
export const GET_SALESCHANNEL_FAIL = "GET_SALESCHANNEL_FAIL";
export const DELETE_SALESCHANNEL = "DELETE_SALESCHANNEL"
export const DELETE_SALESCHANNEL_SUCCESS = "DELETE_SALESCHANNEL_SUCCESS"
export const DELETE_SALESCHANNEL_FAIL = "DELETE_SALESCHANNEL_FAIL"
export const UPDATE_SALESCHANNEL = "UPDATE_SALESCHANNEL"
export const UPDATE_SALESCHANNEL_SUCCESS = "UPDATE_SALESCHANNEL_SUCCESS"
export const UPDATE_SALESCHANNEL_FAIL = "UPDATE_SALESCHANNEL_FAIL"
export const ADD_NEW_SALESCHANNEL = "ADD_NEW_SALESCHANNEL"
export const ADD_SALESCHANNEL_SUCCESS = "ADD_SALESCHANNEL_SUCCESS"
export const ADD_SALESCHANNEL_FAIL = "ADD_SALESCHANNEL_FAIL"